/**
 * @description Component-SymbolSelector
 */
import './index.less';

import { FC, useCallback, useMemo } from 'react';

import { Select } from '@/components/Select';

import DownIcon from '@/assets/svg/dropdown.svg?react';
import { TokenInfo } from '@/types/token';
import { SelectProps } from 'antd/es/select';

interface IPropTypes {
  className?: string;
  baseToken?: TokenInfo;
  quoteToken?: TokenInfo;
  isBase: boolean;
  onChange: (isBase: boolean) => void;
}

const SymbolSelector: FC<IPropTypes & SelectProps> = function ({
  baseToken,
  quoteToken,
  dropdownStyle,
  dropdownAlign = { points: ['tr', 'br'], offset: [0, 4] },
  popupMatchSelectWidth,
  isBase,
  onChange,
}) {
  const handleChange = useCallback(
    (newValue: string) => {
      onChange(newValue === 'base');
    },
    [onChange],
  );

  const options = useMemo(() => {
    const opts = [];
    if (baseToken) {
      opts.push({ value: 'base', label: baseToken.symbol });
    }
    if (quoteToken) {
      opts.push({ value: 'quote', label: quoteToken.symbol });
    }
    return opts;
  }, [baseToken, quoteToken]);

  const currentValue = useMemo(() => {
    return baseToken ? (isBase ? 'base' : 'quote') : '';
  }, [isBase, baseToken]);

  return (
    <Select
      suffixIcon={<DownIcon className="syn-symbol-selector-icon" />}
      options={options}
      value={currentValue}
      popupClassName="syn-symbol-selector-popup"
      onChange={handleChange}
      placement="bottomRight"
      popupMatchSelectWidth={popupMatchSelectWidth}
      dropdownStyle={dropdownStyle}
      dropdownAlign={dropdownAlign}
      className="syn-symbol-selector"
    />
  );
};

export default SymbolSelector;
